import { useContext, useEffect, useState } from 'react'
import UserContext from 'shared/contexts/user'
import { CreationToolUploadContext } from '../../../manager'
import { CopilotContext } from '../../context'
import { hasUploadContextChanged } from '../../utils/upload'

export function useLabel() {
    const { activePresetId, hasChanges, getActivePreset } = useContext(CopilotContext)
    const { user } = useContext(UserContext)
    const uploadContext = useContext(CreationToolUploadContext)
    const [state, setState] = useState<string>('')

    useEffect(() => {
        const preset = getActivePreset()
        const uploadContextChanged = hasUploadContextChanged(uploadContext, user.username)

        if (preset) {
            setState(preset.name)
        } else if (uploadContextChanged) {
            setState('Create a Preset')
        } else {
            setState('Choose a Preset')
        }
    }, [
        activePresetId,
        hasChanges,
        uploadContext.channelId,
        uploadContext.isPublic,
        uploadContext.rating,
        uploadContext.sourceUrl,
        uploadContext.tags,
        uploadContext.username,
        user.username,
    ])

    return state
}
